import React from 'react';
import software_icon from '../../images/software_icon.png';
import hardware_icon from '../../images/hardware_icon.png';
import mechanical_icon from '../../images/mechanical_icon.png';
import clinical_trial_icon from '../../images/clinical_trial_icon.png';
import fda_approval_icon from '../../images/fda_approval_icon.png';
import patent_icon from '../../images/patent_icon.png';
import {Panel, PanelType} from '../../components';
import {BrowserView, MobileView, isMobile} from "react-device-detect";

export const CapabilitiesPanel: React.FC = () => {

    const Capability = ({ name, description, icon }: { name: string; description: string; icon: string }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: isMobile ? 'center' : 'flex-start',
                justifyContent: 'flex-start',
                marginTop: '50px',
                width: isMobile ? '100%' : '30%'
            }}>
                <div style={{
                    height: '40px',
                    opacity: '0.40',
                    marginBottom: '10px',
                }}>
                    <img src={icon} height="40px" alt={name} />
                </div>
                <div style={{
                    fontSize: '2rem',
                    textAlign: isMobile ? 'center' : 'left',
                    marginBottom: '10px',
                }}>{name}</div>
                <div style={{
                    fontSize: '1rem',
                    textAlign: isMobile ? 'center' : 'left',
                }}>{description}</div>
            </div>
        );
    };


    return (
        <>
            <MobileView>
                <Panel type={PanelType.MEDIUM} style={{
                    paddingTop: '45px',
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        marginLeft: '25px',
                        marginRight: '25px',
                    }}>

                        <div style={{
                            fontSize: '2.5rem',
                            fontWeight: 500,
                            textAlign: 'center',
                            width: '100%',
                            lineHeight: 1.3,
                        }}>
                            Comprehensive<br/>Expertise
                            <span style={{
                                fontSize: '1.1rem',
                                color: 'rgb(150, 150, 150)'
                            }}><br/>ALL UNDER ONE ROOF
                            </span>
                        </div>
                            <Capability name="Software & Data Science" description="Expertise in embedded development, cloud systems, artificial intelligence, and algorithm development. All with an explicit focus on medical devices." icon={software_icon} />
                            <Capability name="Hardware" description="Expertise in developing reliable, high-performance systems tailored to meet specific operational demands and ensure robustness, efficiency, and cost-effectiveness." icon={hardware_icon} />
                            <Capability name="Mechanical" description="Expertise in precision mechanical design, integrating form, function, and manufacturability. From intricate assemblies to full-scale systems, we engineer solutions built to last." icon={mechanical_icon} />
                            <Capability name="Clinical Trials" description="Experience in navigating the complexities of clinical research with strategic planning and rigorous execution. With a focus on efficiency and compliance to bring innovations to market faster." icon={clinical_trial_icon} />
                            <Capability name="FDA Certification" description="Experience guiding products through FDA certification with expertise and attention to detail. We streamline the pathway from concept to compliant, market-ready product." icon={fda_approval_icon} />
                            <Capability name="IP & Patents" description="Experience in intellectual property to safeguard innovations with strategic patent development and protection." icon={patent_icon} />
                    </div>
                </Panel>
            </MobileView>


            <BrowserView>
                <Panel type={PanelType.MEDIUM}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        marginLeft: '75px',
                        marginRight: '75px'
                    }}>

                        <div style={{
                            fontSize: '3.5rem'
                        }}>
                            Comprehensive Expertise
                            <span style={{
                                fontSize: '1.1rem',
                                color: 'rgb(150, 150, 150)'
                            }}>
                    — all under one roof.
                </span>
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '60px',
                        }}>
                            <Capability name="Software & Data Science" description="Expertise in embedded development, cloud systems, artificial intelligence, and algorithm development. All with an explicit focus on medical devices." icon={software_icon} />
                            <Capability name="Hardware" description="Expertise in developing reliable, high-performance systems tailored to meet specific operational demands and ensure robustness, efficiency, and cost-effectiveness." icon={hardware_icon} />
                            <Capability name="Mechanical" description="Expertise in precision mechanical design, integrating form, function, and manufacturability. From intricate assemblies to full-scale systems, we engineer solutions built to last." icon={mechanical_icon} />
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '60px',
                        }}>
                            <Capability name="Clinical Trials" description="Experience in navigating the complexities of clinical research with strategic planning and rigorous execution. With a focus on efficiency and compliance to bring innovations to market faster." icon={clinical_trial_icon} />
                            <Capability name="FDA Certification" description="Experience guiding products through FDA certification with expertise and attention to detail. We streamline the pathway from concept to compliant, market-ready product." icon={fda_approval_icon} />
                            <Capability name="IP & Patents" description="Experience in intellectual property to safeguard innovations with strategic patent development and protection." icon={patent_icon} />
                        </div>
                    </div>
                </Panel>
            </BrowserView>
        </>
    );

};